export const normalizeMarkdownLists = (markdown = ''): string => {
  if (!markdown) return '';
  return markdown
    .replace(/(\d+)\.\t/g, '$1. ') // regex for ordered lists
    .replace(/•\t/g, '* '); // regex to replace bullet points and tabs immediately after
};
export default normalizeMarkdownLists;
